import * as React from "react";
const SvgKnifeWiperEnable = (props) => /* @__PURE__ */ React.createElement("svg", { id: "b", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 53 53", height: "1em", ...props }, /* @__PURE__ */ React.createElement("g", { id: "c" }, /* @__PURE__ */ React.createElement("path", { id: "d", d: "M1.39,46.77L43.33,4.83l8.39,8.39-16.78,16.78,5.59,5.59c-9.93,10.75-25.03,15.07-39.15,11.18", style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2.5px"
} })));
export default SvgKnifeWiperEnable;
